import React, { useState } from "react";
import weddingImage from "../../assets/hands-indian-bride-groom-intertwined-together-making-authentic-wedding-ritual.jpg";
import preWeddingImage from "../../assets/prewedding.png";
import babyShowerImage from "../../assets/babyshower.jpg";
import birthdayImage from "../../assets/birthday.jpg";
import eventImage from "../../assets/ Event.jpg";

const Portfolio = () => {
  const [active, setActive] = useState("All");

  const images = [
    { id: 1, category: "Wedding", title: "Wedding Ceremony", image: weddingImage },
    { id: 2, category: "Wedding", title: "Wedding Celebration", image: weddingImage },
    { id: 3, category: "Pre Wedding", title: "Pre-Wedding Shoot", image: preWeddingImage },
    { id: 4, category: "Baby Shower", title: "Baby Shower Moments", image: babyShowerImage },
    { id: 5, category: "Events", title: "Corporate Event", image: eventImage },
    { id: 6, category: "Birthday", title: "Birthday Celebration", image: birthdayImage },
  ];

  const filters = ["All", "Wedding", "Pre Wedding", "Baby Shower", "Birthday", "Events"];

  const filtered = active === "All" ? images : images.filter((item) => item.category === active);

  return (
    <section id="portfolio" className="bg-gradient-to-b from-black to-gray-950 py-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-[2px] bg-gradient-to-r from-amber-400 to-transparent"></div>
            <p className="text-xs uppercase tracking-[4px] text-amber-400 font-bold">
              Portfolio
            </p>
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-white">
            Moments We Captured
          </h2>
        </div>

        <div className="flex flex-wrap gap-3 mb-16">
          {filters.map((item) => (
            <button
              key={item}
              onClick={() => setActive(item)}
              className={`px-6 py-2.5 uppercase text-xs tracking-[2px] font-bold transition-all duration-300 ${
                active === item
                  ? "bg-white text-black shadow-lg"
                  : "border border-gray-700 text-white hover:border-amber-400 hover:text-amber-400"
              }`}
            >
              {item}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((item, idx) => (
            <div
              key={item.id}
              className="group relative overflow-hidden bg-gradient-to-br from-gray-800 to-black aspect-[3/4] cursor-pointer"
            >
              {/* Actual Image */}
              <img
                src={item.image}
                alt={item.title}
                className="absolute inset-0 h-full w-full object-cover transition-all duration-700 group-hover:scale-110"
              />
              {/* Gradient Overlays */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent z-10"></div>
              <div className="absolute inset-0 bg-gradient-to-br from-amber-400/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20"></div>

              {/* Title and Category info sliding up */}
              <div className="absolute bottom-0 left-0 right-0 p-6 z-30 translate-y-6 group-hover:translate-y-0 transition-all duration-300">
                <h3 className="text-xl font-bold text-white">{item.title}</h3>
                <p className="text-xs text-amber-400 font-bold mt-1 uppercase tracking-[2px]">{item.category}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;